import ahmedabad from '../pages/FixtureResult/Image/Teams/Ahmedabad.webp';
import bengaluru from '../pages/FixtureResult/Image/Teams/Bengaluru.webp';
import calicut from '../pages/FixtureResult/Image/Teams/Calicut.webp';
import chennai from '../pages/FixtureResult/Image/Teams/Chennai.webp';
import delhi from '../pages/FixtureResult/Image/Teams/Delhi.webp';
import goa from '../pages/FixtureResult/Image/Teams/Goa.webp';
import hyderabad from '../pages/FixtureResult/Image/Teams/Hyderabad.webp';
import kochi from '../pages/FixtureResult/Image/Teams/Kochi.webp';
import kolkata from '../pages/FixtureResult/Image/Teams/Kolkata.webp';
import mumbai from '../pages/FixtureResult/Image/Teams/Mumbai.webp';

export const HOME_TEAM = 'Delhi Toofans';

export const TEAM_LOGOS = {
  'Ahmedabad Defenders': ahmedabad,
  'Bengaluru Torpedoes': bengaluru,
  'Calicut Heroes': calicut,
  'Chennai Blitz': chennai,
  'Delhi Toofans': delhi,
  'Goa Guardians': goa,
  'Hyderabad Black Hawks': hyderabad,
  'Kochi Blue Spikers': kochi,
  'Kolkata Thunderbolts': kolkata,
  'Mumbai Meteors': mumbai,
};
